import useTranslate from 'modules/local/useTranslate'
import {useState} from 'react'
import {NullAsDefault} from 'views/Shared'
import {notifyOnError} from "../../factory/createErrorEvent";
import {bindQueryParam} from "../../functions/routerHelper";
import {NotificationActionTypes, successNotify} from "../../factory/createNotification";
import useAsyncAction from "../../../../modules/asyncCache/useAsyncAction";
import {
    event_location_createEventLocation_Api,
    event_location_deleteEventLocation_Api,
    event_location_resetSecretKey_Api,
    event_location_updateEventLocation_Api
} from "../../../../apis/event";


export const useEventLocationApi = ({
                                        notifyListeners = {
                                            onCreated: undefined,
                                            onUpdated: undefined,
                                            onDeleted: undefined,
                                        },
                                    }) => {
    const t = useTranslate()
    const [action, setAction] = useState({type: undefined, value: undefined})

    const {
        onCreated = NullAsDefault,
        onUpdated = NullAsDefault,
        onDeleted = NullAsDefault,
    } = notifyListeners ?? {}

    const onError = notifyOnError(t)

    const {handleAsyncAction: createEventLocation, ...asyncCreating} = useAsyncAction({
        onError,
        query: bindQueryParam({}),
        apiInfo: event_location_createEventLocation_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.CREATE, t)
            onCreated(result, data)
        },
    })

    const {handleAsyncAction: updateEventLocation, ...asyncUpdating} = useAsyncAction({
        onError,
        apiInfo: event_location_updateEventLocation_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.UPDATE, t)
            onUpdated(result, data)
        },
    })

    const {handleAsyncAction: deleteEventLocation, ...asyncDeleting} = useAsyncAction({
        onError,
        apiInfo: event_location_deleteEventLocation_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.DELETE, t)
            onDeleted(result, data)
        },
    })


    const {handleAsyncAction: resetSecretKey, ...asyncSecretKeyReseting} = useAsyncAction({
        onError,
        apiInfo: event_location_resetSecretKey_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.UPDATE, t)
            onUpdated(result, data)
        },
    })


    return {
        createEventLocation,
        updateEventLocation,
        deleteEventLocation,
        resetSecretKey,
        asyncCreating,
        asyncUpdating,
        asyncDeleting,
        asyncSecretKeyReseting
    }
}



